





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser } from '@/interfaces/user';
import { IGroup } from '../../interfaces/group';
import IDevice from '../../interfaces/device';

@Component({
  components: {
  },
})
export default class GroupDevices extends Vue {
  @Prop({ required: true })
  public group!: IGroup;

  public get devices(): IDevice[] {
    return this.group && this.group.devices;
  }

  
}
